import React, {Component} from 'react';
import './OverviewScreen.css';
import PortalScreen from "../PortalScreen";
import OverviewScreenWidget from "./OverviewScreenWidget";
import SessionHelper from "../../System/SessionHelper";
import ProgressIndicator from "../Parts/ProgressIndicator";
import axios from 'axios';
import ArrowLink from "../../Common/ArrowLink";

export default class OverviewScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingStats: false,
            loadingWishStats: false,
            loadingWishStatsP: false,

            stats: null,
            wishlistStats: null,
            wishlistStatsP: null
        };
    }

    componentDidMount() {
        this.setState({
            loadingStats: true,
            loadingWishStats: true,
            loadingWishStatsP: true
        });

        // -------------------------------------------------------------------------------------------------------------

        SessionHelper.fetch(true)
            .then((data) => {
                this.setState({
                    stats: data.stats
                });
            })
            .then(() => {
                this.setState({
                    loadingStats: false
                });
            });

        // -------------------------------------------------------------------------------------------------------------

        axios.get('/wishlist/overview?list=wensen')
            .then((res) => {
                if (res.data.ok) {
                    this.setState({
                        wishlistStats: res.data.stats
                    });
                }
            })
            .catch((err) => {
                console.error('Wishlist stats GET failed', err);
            })
            .then(() => {
                this.setState({
                    loadingWishStats: false
                });
            })

        // -------------------------------------------------------------------------------------------------------------

        axios.get('/wishlist/overview?list=praktisch')
            .then((res) => {
                if (res.data.ok) {
                    this.setState({
                        wishlistStatsP: res.data.stats
                    });
                }
            })
            .catch((err) => {
                console.error('Praktisch stats GET failed', err);
            })
            .then(() => {
                this.setState({
                    loadingWishStatsP: false
                });
            })
    }

    render() {
        let guestListStats = <span>Nog geen genodigden</span>;

        let wishlistStats = <span>Nog niet gestart met invullen</span>;
        let wishlistStatsP = <span>Nog niet gestart met invullen</span>;

        let wishlistPercentage = 0;
        let wishlistPercentageP = 0;

        let taskStatsV = <span>Geen openstaande taken</span>;
        let taskStatsT = <span>Geen taken ingepland</span>;
        let taskStatsN = <span>Geen openstaande taken</span>;

        let taskPercentages = {
            "voor": 0,
            "tijdens": 0,
            "na": 0
        };

        if (this.state.stats) {
            if (this.state.stats.guest_count > 0) {
                guestListStats =
                    (
                        <div>
                            <span>{this.state.stats.guest_count}</span> {this.state.stats.guest_count === 1 ? "genodigde" : "genodigden"}
                        </div>
                    );
            }
        } else {
            guestListStats = <span>Gegevens worden opgehaald...</span>;
        }

        if (this.state.stats && this.state.stats.planner) {
            let plannerDt = this.state.stats.planner.detail;

            Object.keys(plannerDt).forEach((key) => {
                let row = plannerDt[key];
                taskPercentages[key] = row.complete / row.total;

                let taskStats = <span><span>{row.complete}</span> van <span>{row.total}</span> taken voltooid</span>;

                switch (key) {
                    case "voor":
                        taskStatsV = taskStats;
                        break;
                    case "tijdens":
                        taskStatsT = <span><span>{row.total}</span> taken ingepland</span>;
                        break;
                    case "na":
                        taskStatsN = taskStats;
                        break;
                    default:
                        break;
                }
            });
        } else {
            taskStatsV = <span>Gegevens worden opgehaald...</span>;
            taskStatsT = <span>Gegevens worden opgehaald...</span>;
            taskStatsN = <span>Gegevens worden opgehaald...</span>;
        }

        if (this.state.wishlistStats) {
            if (this.state.wishlistStats.qualifying_answered > 0) {
                wishlistStats =
                    <span><span>{this.state.wishlistStats.qualifying_answered}</span> van <span>{this.state.wishlistStats.qualifying}</span> vragen ingevuld</span>
            }

            wishlistPercentage = this.state.wishlistStats.q_percentage;
        } else {
            wishlistStats = <span>Gegevens worden opgehaald...</span>
        }

        if (this.state.wishlistStatsP) {
            if (this.state.wishlistStatsP.qualifying_answered > 0) {
                wishlistStatsP =
                    <span><span>{this.state.wishlistStatsP.qualifying_answered}</span> van <span>{this.state.wishlistStatsP.qualifying}</span> vragen ingevuld</span>
            }

            wishlistPercentageP = this.state.wishlistStatsP.q_percentage;
        } else {
            wishlistStatsP = <span>Gegevens worden opgehaald...</span>
        }

        let busy = this.state.loadingStats || this.state.loadingWishStats || this.state.loadingWishStatsP;

        return (
            <PortalScreen tab={"start"} title={"Overzicht"} isLoading={busy}
                          subText={"Overzicht van de beschikbare tools."}>
                <div className={"OverviewScreen"}>

                    <div className={"OverviewScreen__widgets"}>

                        <OverviewScreenWidget title={"Wensenlijst"} iconName={"check-decagram"} linkTo={"/wensen"}
                                              text={"Aan de hand van vragen en inspirerende voorbeelden helpen we jou om je wensen voor het afscheid vast te leggen."}>
                            <div className={"OverviewScreen__subw"}>
                                {wishlistStats}
                                <ProgressIndicator small={true} value={wishlistPercentage}/>
                            </div>
                        </OverviewScreenWidget>

                        <OverviewScreenWidget title={"Praktische zaken"} iconName={"gavel"} linkTo={"/praktisch"}
                                              text={"Aan de hand van onze tips en adviezen kun je belangrijke zaken voorbereiden en vastleggen."}>
                            <div className={"OverviewScreen__subw"}>
                                {wishlistStatsP}
                                <ProgressIndicator small={true} value={wishlistPercentageP}/>
                            </div>
                        </OverviewScreenWidget>

                        <OverviewScreenWidget title={"Genodigdenlijst"} iconName={"account"} linkTo={"/gasten"}
                                              text={"Geef aan wie je op de uitvaart wil met daarbij ook contact- en adresgegevens. Zo kun je bijhouden wie er uitgenodigd moet worden."}>
                            <div className={"OverviewScreen__subw"}>
                                {guestListStats}
                            </div>
                        </OverviewScreenWidget>

                        <OverviewScreenWidget title={"Draaiboek"} iconName={"calendar-clock"} linkTo={null}
                                              text={"Hierin staat omschreven hoe de dagen voorafgaand, tijdens en na het afscheid er uit zien en waar je rekening mee moet houden."}>
                            <div className={"OverviewScreen__subw"}>
                                <ArrowLink label={"Voor de uitvaart"} to={"/draaiboek/voor"} routerLink={true}/>
                                {taskStatsV}
                                <ProgressIndicator small={true} value={taskPercentages["voor"]}/>
                            </div>
                            <div className={"OverviewScreen__subw"}>
                                <ArrowLink label={"Tijdens de uitvaart"} to={"/draaiboek/tijdens"} routerLink={true}/>
                                {taskStatsT}
                            </div>
                            <div className={"OverviewScreen__subw"}>
                                <ArrowLink label={"Na de uitvaart"} to={"/draaiboek/na"} routerLink={true}/>
                                {taskStatsN}
                                <ProgressIndicator small={true} value={taskPercentages["na"]}/>
                            </div>
                        </OverviewScreenWidget>
                    </div>

                </div>
            </PortalScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Overview/OverviewScreen.js